<template>
  <div class="modal-lang" v-show="visibilityFlag">
    <div class="mask"></div>
    <img src="../assets/images/close.png" @click="close" class="close" alt />
    <div class="lang">
      <p
        @click="selectLang(item.key)"
        v-for="(item,index) in $t('home.lang')"
        :key="index"
        :style="{'color':item.key===lang?'white':'grey'}"
      >{{item.title}}</p>
    </div>
  </div>
</template>

<script>
import { value, onMounted } from "vue-function-api";
import { setUp } from "../locales/index";
export default {
  props: {
    visibilityFlag: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectLang: function (lang_key){
      setUp(lang_key);
      this.$root.$i18n.locale = lang_key
      this.lang = lang_key;
      // close the language menu
      this.$emit("update:visibilityFlag", false);
    }
  },
  setup(props, context) {
    const lang = value("");
    const close = () => {
      context.emit("update:visibilityFlag", false);
    };
    const select = key => {
      lang.value = key;
      window.localStorage.setItem("localeLanguage", key.replace(/-/, "_"));
      setUp();
    };
    onMounted(() => {
      lang.value = window.localStorage.getItem("localeLanguage");
    });
    return {
      close,
      lang,
      select
    };
  }
};
</script>

<style lang="scss" scoped>
// $u: 0.01333333334;
// $h: $u * 190rem;
// .modal-lang {
//   z-index: 1002;
//   width: 100%;
//   background-size: 100% 100%;
//   position: relative;
//   box-sizing: border-box;
//   position: relative;
//   height: 100vh;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   position: fixed;
//   top: 0;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   .mask {
//     z-index: 1;
//     width: 100%;
//     position: absolute;
//     top: 0;
//     left: 0;
//     bottom: 0;
//     right: 0;
//     background: url("../assets/images/mask.png") center no-repeat;
//     background-size: 100% 100%;
//   }
//   .close {
//     z-index: 1002;
//     width: $u * 32rem;
//     height: $u * 32rem;
//     position: absolute;
//     right: $u * 50rem;
//     top: $u * 100rem;
//   }
//   .lang {
//     z-index: 1002;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     flex-direction: column;
//     width: 100%;
//     p {
//       width: 30%;
//       text-align-last: justify;
//       margin: 0;
//       font-weight: 600;
//       font-size: $u * 38rem;
//       color: white;
//       text-align: justify;
//       margin-bottom: $u * 40rem;
//       &::after {
//         content: "";
//         display: inline-block;
//         width: 100%;
//       }
//     }
//   }
// }
</style>